import { render, staticRenderFns } from "./LastWeekProduction.vue?vue&type=template&id=4d07a89f"
import script from "./LastWeekProduction.vue?vue&type=script&setup=true&lang=js"
export * from "./LastWeekProduction.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports